export type LinkItem = {
  id: string;
  slug: string;
  title: string;
  url: string;
  description?: string;
  position: number;
};

export type SocialLink = {
  type: "website" | "shopee" | "instagram" | "tiktok";
  label: string;
  slug: string;
  url: string;
};

export const profile = {
  handle: "cokie.typo",
  title: "cokie.typo",
  description: "Tiệm đồ tên bánh",
  avatarPath: "/assets/cokie-avatar.png",
  theme: {
    background: "#FFFFFF",
    text: "#502274",
    buttonBackground: "#FFFFFF",
    buttonText: "#502274",
    fontFamily: "IBM Plex Sans"
  }
} as const;

export const links: LinkItem[] = [
  {
    id: "587097650",
    slug: "website",
    title: "Website",
    url: "https://cokie.store",
    description:
      "COKIE TYPO - thời trang hằng ngày với form gọn, typography sắc nét và các sản phẩm dễ phối.",
    position: 0
  },
  {
    id: "586976895",
    slug: "shopee",
    title: "Shopee",
    url: "https://shopee.vn/cokie.typo",
    position: 1
  },
  {
    id: "495967398",
    slug: "instagram",
    title: "Instagram",
    url: "https://www.instagram.com/cokie.typo",
    position: 2
  },
  {
    id: "587097373",
    slug: "tiktok",
    title: "TikTok",
    url: "https://www.tiktok.com/@cokie.typo",
    description: "TikTok",
    position: 3
  }
];

export const socialLinks: SocialLink[] = [
  {
    type: "website",
    label: "cokie.typo Website",
    slug: "website",
    url: "https://cokie.store"
  },
  {
    type: "shopee",
    label: "cokie.typo Shopee",
    slug: "shopee",
    url: "https://shopee.vn/cokie.typo"
  },
  {
    type: "instagram",
    label: "cokie.typo Instagram",
    slug: "instagram",
    url: "https://www.instagram.com/cokie.typo"
  },
  {
    type: "tiktok",
    label: "cokie.typo TikTok",
    slug: "tiktok",
    url: "https://www.tiktok.com/@cokie.typo"
  }
];

export function getLinkBySlug(slug: string): LinkItem | undefined {
  return links.find((link) => link.slug === slug);
}
